import React, { Dispatch, useState, useEffect } from 'react';
import { Button, Modal, Tabs, Select, Form } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { Action } from 'typesafe-actions';
import { ApplicationState } from '../../../../../../store';
import { selectTransportadoraParceiraRequest } from '../../../../../../store/ducks/transportadoras/actions';
import TabsSelectRegister from '../../../../../../components/TabsSelectRegister';
import { CriaTransportadora } from './services/estoqueServices';
import Swal from 'sweetalert2';
import mask from '../../../../../../utils/mask';
import { ROLE } from '../../../../../../utils/roles';
import TitlePage from 'components/TitlePage';

interface ITomador {
  codTomador: number;
  setTransportadoraKey: React.Dispatch<React.SetStateAction<number | null>>;
  disabled: boolean;
  setClienteRetira: React.Dispatch<React.SetStateAction<boolean>>;
  props?: any;
}
const ModalTransportadora: React.FC<ITomador> = ({
  codTomador,
  setTransportadoraKey,
  disabled,
  setClienteRetira,
  props = [],
}) => {
  const { Option } = Select;
  const [form] = Form.useForm();
  const [formNova] = Form.useForm();
  const dispatch = useDispatch<Dispatch<Action>>();
  const { TabPane } = Tabs;

  const transportadoras = useSelector((state: ApplicationState) => state.Transportadoras.data);
  const cddAtivo = useSelector((state: ApplicationState) => state.auth.cddAtivo?.codCdd);
  const cidade = useSelector((state: ApplicationState) => state.EstadoCidade.cidadeSelecionada);
  const cnpj = useSelector((state: ApplicationState) => state.EstadoCidade.cnpjSelecionado);
  const nome = useSelector((state: ApplicationState) => state.EstadoCidade.nomeSelecionado);
  const perfil = useSelector((state: ApplicationState) => state.auth.user?.perfil);
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth?.inscricaoAtiva);
  const nomeParc = useSelector((state: ApplicationState) => state.EstadoCidade.nomeParcSelecionado);

  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [tabsSelect, setTabsSelect] = useState<string>('1');
  const [isTransSelect, setIsTransSelect] = useState<any>(props.transportadora);

  const hadleSelect = (value: string, e: any) => {
    setTransportadoraKey(+e.key);
    setIsTransSelect(e.value);
  };

  useEffect(() => {
    dispatch(selectTransportadoraParceiraRequest(cddAtivo as number, inscricaoAtiva));
  }, [dispatch, cddAtivo, inscricaoAtiva]);

  const handleok = () => {
    setClienteRetira(false);

    if (tabsSelect === '1') {
      form.validateFields().then(async (e) => {
        setIsModalVisible(false);
      });
    }
    if (tabsSelect !== '1' && nomeParc) {
      setTransportadoraKey(nomeParc.codParceiro);
      setIsTransSelect(nomeParc.nomeParceiro);
      setIsModalVisible(false);
    }

    if (tabsSelect === '2' && !nomeParc) {
      try {
        CriaTransportadora.criaTransportadora(inscricaoAtiva, nome, cnpj, cidade)
          .then((res) => {
            Swal.fire({
              title: 'Transportadora criada com sucesso!',
              html: '',
              icon: 'success',
              showConfirmButton: false,
              timer: 1500,
            });
            setTransportadoraKey(res.data.codParceiro);
            setIsTransSelect(res.data.nome);
            // dispatch(loadRequestTransp(inscricaoAtiva[0], cddAtivo));
            dispatch(selectTransportadoraParceiraRequest(cddAtivo as number, inscricaoAtiva));
          })
          .catch(function (error) {
            if (error.response.data.Erro) {
              Swal.fire({
                title: 'Opss...',
                html: `${error.response?.data?.Erro}`,
                icon: 'warning',
              });
            } else {
              Swal.fire({
                title: 'Opss...',
                html:
                  'Não foi possivel criar a transportadora, por favor tente novamente, se persistir contate o suporte técnico!',
                icon: 'warning',
              });
            }
          });
      } catch (error: any) {
        if (error.response.data.Erro) {
          Swal.fire({
            title: 'Opss...',
            html: `${error.response?.data?.Erro}`,
            icon: 'warning',
          });
        } else {
          Swal.fire({
            title: 'Opss...',
            html:
              'Não foi possivel criar a transportadora, por favor tente novamente, se persistir contate o suporte técnico!',
            icon: 'warning',
          });
        }
      } finally {
        setIsModalVisible(false);
      }
    }

    if (tabsSelect === '3') {
      setClienteRetira(true);
      setIsTransSelect('Cliente Retira');
      setTransportadoraKey(+codTomador);
      setIsModalVisible(false);
    }
    handleCancel();
  };

  const handleCancel = () => {
    form.resetFields();
    formNova.resetFields();
  };

  return (
    <>
      <Modal
        centered
        title={<TitlePage>Transportadoras</TitlePage>}
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        maskClosable={true}
        closable={true}
        destroyOnClose={true}
        closeIcon={<CloseOutlined />}
        keyboard={true}
        width={850}
        footer={[
          <Button
            data-cy="btnOk"
            disabled={
              tabsSelect === '2' && cnpj !== undefined
                ? false
                : tabsSelect === '1' && !!isTransSelect?.length
                ? false
                : tabsSelect === '3'
                ? false
                : true
            }
            type="primary"
            key="back"
            size="middle"
            onClick={handleok}
          >
            OK
          </Button>,
        ]}
      >
        <Tabs
          onChange={(e) => {
            setTabsSelect(e);
          }}
          defaultActiveKey={tabsSelect}
        >
          <TabPane tab="Transportadoras cadastradas" key="1">
            <Form form={form}>
              <Form.Item
                rules={[{ required: true, message: 'Selecione uma transportadora' }]}
                name="transportadora"
              >
                <Select
                  onSelect={hadleSelect}
                  placeholder="Selecione uma transportadora"
                  filterOption={(inputValue, element) =>
                    element?.props.children
                      .toString()
                      .toLowerCase()
                      .replace(/\.|-|\//g, '')
                      .includes(inputValue.replace(/\.|\/|-/g, '').toLowerCase())
                  }
                  showSearch
                >
                  {transportadoras?.map((item: any) => {
                    if (perfil === ROLE.TRANSPORTADORA) {
                      return (
                        <Option
                          key={item.codParceiro}
                          value={mask('transportadoraUf', item.nomeParceiro)}
                        >
                          {mask('transportadoraUf', item.nomeParceiro)}
                          <br />
                          {mask('cpfCnpj', item?.cnpj)}
                        </Option>
                      );
                    } else {
                      return (
                        item.nomeParceiro !== 'Cliente Retira' && (
                          <Option
                            key={item.codParceiro}
                            value={mask('transportadoraUf', item.nomeParceiro)}
                          >
                            {mask('transportadoraUf', item.nomeParceiro)}
                            <br />
                            {mask('cpfCnpj', item?.cnpj)}
                          </Option>
                        )
                      );
                    }
                  })}
                </Select>
              </Form.Item>
            </Form>
          </TabPane>

          {perfil !== ROLE.TRANSPORTADORA && (
            <>
              <TabPane tab="Nova transportadora" key="2">
                <Form form={formNova}>
                  <Form.Item
                    rules={[{ required: true, message: 'Selecione uma transportadora' }]}
                    name="transportadoraAuto"
                  >
                    <TabsSelectRegister children={'Nome da transportadora'} />
                  </Form.Item>
                </Form>
              </TabPane>

              <TabPane tab="Cliente Retira / Entrega" key="3">
                <h3>O cliente vai efetuar a retirada/entrega</h3>
              </TabPane>
            </>
          )}
        </Tabs>
      </Modal>
      <Button
        data-cy="transportadora"
        style={{
          width: '100%',
        }}
        title={`${isTransSelect}`}
        type="dashed"
        onClick={() => setIsModalVisible(true)}
        disabled={disabled}
      >
        <span
          style={{
            width: '100%',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {!isTransSelect ? (
            <span style={{ color: '#bbb' }}>Selecione uma transportadora</span>
          ) : (
            isTransSelect
          )}
        </span>
      </Button>
    </>
  );
};

export default ModalTransportadora;
